// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"CampaignInduction_componentStyle__BK6QZ","drawButton":"CampaignInduction_drawButton__nTJfJ"};